import type { CatalogueState } from '../lib/measurements.js';

export function CatalogueNotice({
  status,
  retry,
  step,
}: {
  status: CatalogueState['status'];
  retry(): void;
  step: 'lock' | 'colour';
}) {
  if (status === 'ready') {
    return null;
  }
  if (status === 'loading') {
    return (
      <p role="status" className="mt-4 text-xs text-gray-500">
        {step === 'colour'
          ? 'Checking colour availability...'
          : 'Checking catalogue availability...'}
      </p>
    );
  }
  return (
    <div role="alert" className="mt-4 text-xs text-red-600">
      <p>
        {status === 'offline'
          ? 'The catalogue check is paused while offline. Reconnect and try again.'
          : 'The catalogue could not be checked. Try again.'}
      </p>
      <button
        type="button"
        data-name={`${step}-catalogue-retry`}
        onClick={retry}
        className="mt-2 min-h-11 font-semibold underline focus-visible:outline-2 focus-visible:outline-brand"
      >
        {step === 'colour' ? 'Retry' : 'Retry catalogue'}
      </button>
    </div>
  );
}
